import { isBlipGoProduct } from '../constants/blip-go.constants';
import { ProductV2 } from '../models/product-v2.model';

import { filterTelemedicineVariationPlans } from './telemedicine-product-variations.util';

const TELEMEDICINE_PRODUCT_NAMES = new Set(['starbem', 'telemedicina', 'telemedicine']);

export interface ProductCardDisplayOptions {
  /** Quando true, remove Blip Go da listagem (produto já contratado). */
  hideBlipGo?: boolean;
}

function getDisplayableVariationPlans(product: ProductV2) {
  const plans = product.variations ?? [];
  if (product.name && TELEMEDICINE_PRODUCT_NAMES.has(product.name.trim().toLowerCase())) {
    return filterTelemedicineVariationPlans(plans);
  }
  return plans;
}

/** Produtos MIND/MOVEL usam preço direto; demais precisam de ao menos uma variação exibível. */
export function isProductDisplayableInCard(product: ProductV2): boolean {
  if (product.productType === 'MIND' || product.productType === 'MOVEL') {
    return true;
  }
  return getDisplayableVariationPlans(product).length > 0;
}

export function filterProductsForCardDisplay(
  products: ProductV2[],
  options?: ProductCardDisplayOptions
): ProductV2[] {
  return (products ?? []).filter(product => {
    if (!isProductDisplayableInCard(product)) {
      return false;
    }
    if (options?.hideBlipGo && isBlipGoProduct(product)) {
      return false;
    }
    return true;
  });
}
